module.exports = __webpack_public_path__ + "static/img/shuixing.2fe7781b.png";